import util from '@/libs/util'
import md5 from 'js-md5'

const analyseUtil = {}

analyseUtil.COLORS = ['#c23531', '#d48265', '#ca8622', '#bda29a', '#91c7ae', '#749f83', '#61a0a8', '#6e7074', '#546570', '#2f4554', '#8dc1a9']
/** 另一套颜色方案 */
analyseUtil.COLOR_SCHEME_A = ['#588C93', '#B7745C', '#c4ccd3', '#4E5C65', '#AF7725', '#A48E87', '#80AC98', '#bda29a', '#688B74', '#636568', '#30424E']

analyseUtil.randomId = function () {
  return Number(Math.random().toString().substr(3, 5) + Date.now()).toString(36)
}

/**
 * 多层级看板跳转时，获取层级搜索条件栈
 * @param vm
 * @returns {Array}
 */
analyseUtil.getStack = function (vm) {
  let stack = util.getLocalStore(analyseUtil.generateStackKey(vm))
  return stack && stack !== null ? JSON.parse(stack) : []
}

/**
 * 设置层级搜索条件栈
 * @param stack
 * @param vm
 */
analyseUtil.setStack = function (stack, vm) {
  util.setLocalStore(analyseUtil.generateStackKey(vm), stack)
}

/**
 * 生成栈key
 * @param vm
 * @returns {string}
 */
analyseUtil.generateStackKey = function (vm) {
  return 'analyse-data-search-stack-' + analyseUtil.getBoardStackKey(vm)
}

/**
 * 获取当前面板的栈key，如果上层board传递进来则使用上层，否则使用当前tab的id
 * @param vm
 * @returns {*}
 */
analyseUtil.getBoardStackKey = function (vm) {
  return vm.$route.query && vm.$route.query.boardStackKey ? vm.$route.query.boardStackKey : vm.$store.state.app.currentTab.id
}

/**
 * 向层级搜索条件栈压入搜索条件
 * @param search
 * @param vm
 */
analyseUtil.pushSearchStack = function (search, vm) {
  let stack = analyseUtil.getStack(vm)
  stack.push(search)
  analyseUtil.setStack(stack, vm)
}

/**
 * 层级搜索条件栈出栈顶
 * @param vm
 */
analyseUtil.popSearchStack = function (vm) {
  let stack = analyseUtil.getStack(vm)
  stack.splice(stack.length - 1, 1)
  analyseUtil.setStack(stack, vm)
}

/**
 * 层级搜索条件栈获取栈顶
 * @param vm
 * @returns {{}}
 */
analyseUtil.peekSearchStack = function (vm) {
  let stack = analyseUtil.getStack(vm)
  return stack && stack !== null ? stack[stack.length - 1] : {}
}

/**
 * 向层级搜索条件栈获取长度
 * @param vm
 * @returns {number}
 */
analyseUtil.searchStackLength = function (vm) {
  let stack = analyseUtil.getStack(vm)
  return stack && stack !== null ? stack.length : 0
}

/**
 * 向层级搜索条件栈调节栈深度与传入深度一致
 * 因为vue的组件的创建销毁会受到刷新影响，所以不能使用destroyed去出栈，只能在初始化时检查query标识的当前栈深度与实际深度的差异调节栈
 * @param deep
 * @param vm
 */
analyseUtil.adjustStack = function (deep, vm) {
  deep = deep !== undefined ? deep : 0
  if (parseInt(deep) > analyseUtil.searchStackLength(vm)) {
    console.error('加载传递参数失败: deep: ' + deep + ', stack length: ' + analyseUtil.searchStackLength(vm))
    return
  }
  while (parseInt(deep) < analyseUtil.searchStackLength(vm)) {
    analyseUtil.popSearchStack(vm)
  }
}

/**
 * 获取当前面板的搜索key，搜索key使用上一层传入的栈key与当前标签id拼接后md5，因为面板可能被复用，所以需要多维度唯一
 * @param vm
 * @returns {*}
 */
analyseUtil.getBoardSearchKey = function (vm) {
  return md5((vm.$route.query && vm.$route.query.boardStackKey ? vm.$route.query.boardStackKey : '') + vm.$store.state.app.currentTab.id)
}

/**
 * 保存搜索条件
 * @param search
 * @param vm
 */
analyseUtil.putBoardSearch = function (search, vm) {
  let key = 'analyse-data-condition-board-' + this.getBoardSearchKey(vm)
  util.setLocalStore(key, search)
}

/**
 * 获取面板的历史搜索条件
 * @param vm
 * @returns {*}
 */
analyseUtil.getBoardSearch = function (vm) {
  let search = util.getLocalStore('analyse-data-condition-board-' + this.getBoardSearchKey(vm))
  return search && search !== null && search !== undefined ? JSON.parse(search) : null
}

/**
 * 获取block的搜索key
 * @param vm
 * @param blockId
 * @returns {string}
 */
analyseUtil.getBlockSearchKey = function (vm, blockId) {
  return analyseUtil.getBoardSearchKey(vm) + '-' + blockId
}

/**
 * 保存块搜索条件
 * @param search
 * @param vm
 * @param blockId
 */
analyseUtil.putBlockSearch = function (search, vm, blockId) {
  let key = 'analyse-data-condition-block-' + this.getBlockSearchKey(vm, blockId)
  util.setLocalStore(key, search)
}

/**
 * 获取块的历史搜索条件
 * @param vm
 * @param blockId
 * @returns {*}
 */
analyseUtil.getBlockSearch = function (vm, blockId) {
  let search = util.getLocalStore('analyse-data-condition-block-' + this.getBlockSearchKey(vm, blockId))
  return search && search !== null && search !== undefined ? JSON.parse(search) : null
}

export default analyseUtil



// WEBPACK FOOTER //
// ./src/custom/components/page/analyse/show/analyse-util.js